import { Dimensions, Alert, Platform } from "react-native";
import Swal from "sweetalert2";
//import Swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import colors from "../constants/colors";

export function getNavigator() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
            return 'chrome'; //Chrome
        } else {
            return 'safari'; // Safari
        }
    }
}
export const getWidth = (width) => {
    switch (width) {
        case 'extramini':
            return "33%";
        case 'mini':
            return 130;
        case "small":
            return 190;
        case "medium":
            return 290;
        case "large":
            return Dimensions.get("window").width * .90;
        default:
            return Dimensions.get("window").width * .90;
    }
}

export const getComponentSubmissionByDefaultLabel = (defaultLabel, components, submission, section_id, position) => {
    var sub = "";
    var component = components.find((component) => component.defaultLabel == defaultLabel && component.section_id == section_id);
    if (component && submission[component.id]) {
        if ((position || position == 0)) {
            sub = submission[component.id][position] ? submission[component.id][position] : "";
        } else {
            sub = submission[component.id];
        }
    }
    //console.log("component: " + component.label + " defaultLabel: " + defaultLabel + " section_id: " + section_id, " sub: " + sub + " position: " + position + " submission: " + JSON.stringify(submission));
    return sub;
}
export const getComponent = (defaultLabel, components, section_id) => {
    var component = components.find((component) => component.defaultLabel == defaultLabel && component.section_id == section_id);
    return component;
}
export const getComponentId = (defaultLabel, components, section_id) => {
    var component = components.find((component) => component.defaultLabel == defaultLabel && component.section_id == section_id);
    return component?.id;
}
export const getComponentByanotherComponentId = (componentId, defaultLabelToFound, components) => {
    var component = components.find((component) => component.id == componentId);
    if (!component) return;
    var section = components.find((comp) => comp.type == "section" && comp.section_id == component.section_id);
    if (!section) return;
    var locationComponent = components.find((component) => component?.defaultLabel == defaultLabelToFound && component.section_id == section.section_id);
    return locationComponent;
}
export function simpleAlert(title, message, confirmTxt, icon, iconColor, close) {
    Swal.fire({
        title,
        html: message,
        confirmButtonText: confirmTxt,
        confirmButtonColor: colors.orange,
        icon,
        iconColor,
        backdrop: false,
        willClose: () => { if (close) close() }
    })
}
export function confirmationAlert(title, text, confirmTxt, cancelTxt, icon, iconColor, close, confirmation, cancel) {
    Swal.fire({
        title,
        text,
        confirmButtonText: confirmTxt,
        confirmButtonColor: colors.orange,
        showCancelButton: cancelTxt ? true : false,
        cancelButtonText: cancelTxt,
        icon,
        iconColor,
        scrollbarPadding: false,
        heightAuto: false,
        willClose: () => { if (close) close() }
    }).then((result) => {
        if (result.isConfirmed) {
            if (confirmation) confirmation();
        } else if (result.isDismissed) {
            if (cancel) cancel();
        }
    })
}
export const getIosCellHeight = (width, value) => {
    var val = 1;
    //console.log("width: " + width);
    switch (width) {
        case 'extramini':
            if (value?.length >= 8) {
                if (value) {
                    val = calculateChars(8);
                } else if (Platform.OS == "ios") val = 1.7;
            }
            break;
        case "mini":
            if (value?.length >= 10) {
                if (value) {
                    val = calculateChars(10);
                } else if (Platform.OS == "ios") val = 1.6;
            }
            break;
        case "small":
            if (value?.length >= 16) {
                if (value) {
                    val = calculateChars(16);
                } else if (Platform.OS == "ios") val = 1.5;
            }
            break;
        case "medium":
            if (value?.length >= 25) {
                if (value) {
                    val = calculateChars(25);
                } else if (Platform.OS == "ios") val = 1.4;
            }
            break;
        case "large":
            if (value?.length >= 29) {
                if (value) {
                    val = calculateChars(29);
                } else if (Platform.OS == "ios") val = 1.3;
            }
            break;
        default:
            if (value?.length >= 32) {
                if (value) {
                    val = calculateChars(32);
                } else if (Platform.OS == "ios") val = 1.5;
            }
            break;
    }
    //console.log('val: ' + val);
    return val;
}
function calculateChars(value) {
    var val = (value?.length / value);
    if (val < 1.00) {
        val = 1;
    } else {
        if (value?.length % value > 0) {
            val = Math.trunc(val);
            val += 1;
        }
    }

    return val;
}
export function getMinChar(width) {
    var chrs = 26;
    switch (width) {
        case "small":
            chrs = 13
            break;
        case "medium":
            break;
        case "large":
            break;
    }
    return chrs;
}
export function getFirstDiv(width) {
    var val = 19;
    switch (width) {
        case "small":
            val = 11
            break;
        case "medium":
            break;
        case "large":
            break;
    }
    return val;
}
export function getSecondDiv(width) {
    var val = 28;
    switch (width) {
        case "small":
            val = 13
            break;
        case "medium":
            val = 19
            break;
        case "large":
            val = 26;
            break;
    }
    return val;
}
export function getThirdDiv(width) {
    var val = 31;
    switch (width) {
        case "small":
            val = 13
            break;
        case "medium":
            val = 24
            break;
        case "large":
            break;
    }
    return val;
}
export function getComponentSubmit(submission, components, defaultLabel, id, position) {
    var sub = "";
    if(!components || components?.length == 0) return sub;
    var itemComponent = components.find(component => component.id == id);
    if (itemComponent && submission) {
        var valueComponent = components.find(component => component.section_id == itemComponent.section_id && component.defaultLabel == defaultLabel);
        if (valueComponent) {
            if (position || position == 0) {
                try {
                    sub = submission[valueComponent.id][position];
                } catch (error) {
                }
            } else {
                sub = submission[valueComponent.id];
            }
        }
    }
    return sub;
}
export function getComponentDefaultSubmit(components, submission, defaultLabel, id, position, dY) {
    var defaultYield = dY ? parseFloat(dY) : 1;
    var itemComponent = components.find(component => component.id == id);
    var sectionComponent = components.find(section => section.type == "section" && itemComponent?.section_id == section?.section_id);
    var defaultSubmission = sectionComponent?.defaultSubmission ? sectionComponent?.defaultSubmission : null;
    var sub = "";
    var valueComponent = components.find(component => component.defaultLabel == "yield"); 
    var value = 1;
    if(valueComponent){
        value = submission[valueComponent.id] ? parseFloat(submission[valueComponent.id]) : 1;
    }

    if (itemComponent && defaultSubmission) {
        //var valueComponent = components.find(component => component.section_id == itemComponent.section_id && component.defaultLabel == defaultLabel);
        if (itemComponent) {
            if (position || position == 0) {
                if((defaultYield != value)){
                    sub = (parseFloat(defaultSubmission[itemComponent.id][position])) * (value / defaultYield);
                }else sub = defaultSubmission[itemComponent.id][position];

            } else {
                if((defaultYield != value)){
                    sub = (parseFloat(defaultSubmission[itemComponent.id])) * (value / defaultYield);
                }else sub = defaultSubmission[itemComponent.id];
                

            }
        }
    }
    //console.log(" - ", position, " - ", id, " - ", sub);
    try {
        if(!validateDecimals(sub.toString()) && sub % 1 != 0){
            sub = sub.toFixed(3);
        }
    } catch (error) {
        sub = "";
    }
    return sub;
}

export function getLotCodeString(lotsSelected) {
    var string = "";
    try {
        if (typeof lotsSelected == "object") {
            lotsSelected.map((lot, idx) => {
                if (idx == 0)
                    if (lotsSelected.length - 1 == idx) string += (lot?.lot ? lot?.lot : lot?.isNew?"": "No Lot"); else string += (lot?.lot ? lot?.lot : "No Lot"); //+ "\n";
            })
        }
    } catch (error) {
        console.log(error);
    }
    return string;
}

/** True when the user has entered/selected an actual lot code string (not just a qty placeholder). */
export function hasLotCodeString(lotValue) {
    if (lotValue == null || lotValue === "") return false;
    if (typeof lotValue === "string") return lotValue.trim().length > 0;
    if (!Array.isArray(lotValue) || lotValue.length === 0) return false;
    return lotValue.some((lot) => {
        if (!lot) return false;
        if (typeof lot === "string") return lot.trim().length > 0;
        return lot.lot != null && String(lot.lot).trim().length > 0;
    });
}

export function isPlaceholderLotObject(lot) {
    return !!(lot && typeof lot === "object" && lot.isNew === true && (!lot.lot || String(lot.lot).trim() === ""));
}

function formatLotEditedAmount(quantity) {
    return (quantity % 1 > 0 && !validateDecimals(quantity.toString())) ? quantity.toFixed(3) : quantity;
}

function getLotComponentForQuantityField(quantityComponent, components) {
    if (!quantityComponent) return null;
    let lotLabel = "lotcode";
    if (quantityComponent.defaultLabel === "quantityFinishedGoods") lotLabel = "lotcode_finished";
    else if (quantityComponent.defaultLabel === "quantityWIP") lotLabel = "lotcode_wip";
    return getComponentByanotherComponentId(quantityComponent.id, lotLabel, components);
}

/**
 * When quantity changes on inventory forms, keep lot editedAmount in sync.
 * If no lot code string exists yet, create/update a placeholder lot row with the quantity.
 */
export function syncLotCodesFromQuantityChange(submission, components, quantityComponent, position, { isReceivingLog, isShipmentLog, isRecipe } = {}) {
    if (!isReceivingLog && !isShipmentLog && !isRecipe) return submission;
    if (!quantityComponent) return submission;

    const inventoryQuantityLabels = [
        "quantity",
        "quantityIngredient",
        "quantityPackaging",
        "quantityFinishedGoods",
        "quantityWIP",
    ];
    if (!inventoryQuantityLabels.includes(quantityComponent.defaultLabel)) return submission;

    const lotComponent = getLotComponentForQuantityField(quantityComponent, components);
    if (!lotComponent) return submission;

    const qtyRaw = (position || position === 0)
        ? submission[quantityComponent.id]?.[position]
        : submission[quantityComponent.id];
    const quantity = parseFloat(qtyRaw);
    if (!quantity || quantity <= 0 || Number.isNaN(quantity)) return submission;

    const lotIdx = (position || position === 0) ? position : 0;
    if (!Array.isArray(submission[lotComponent.id])) submission[lotComponent.id] = [];
    const currentLots = submission[lotComponent.id][lotIdx];

    const unitsComponent = getComponentByanotherComponentId(lotComponent.id, "units", components);
    let units = "";
    if (unitsComponent) {
        units = getComponentSubmissionByDefaultLabel(
            unitsComponent.defaultLabel,
            components,
            submission,
            unitsComponent.section_id,
            position
        );
    }

    if (!hasLotCodeString(currentLots)) {
        // Shipment log lot preselection is handled by Lotcode (getItemByName + FIFO allocation).
        if (isShipmentLog) {
            return submission;
        }
        if (Array.isArray(currentLots) && currentLots.length > 0 && currentLots.every(isPlaceholderLotObject)) {
            submission[lotComponent.id][lotIdx] = currentLots.map((lot) => ({
                ...lot,
                editedAmount: formatLotEditedAmount(quantity),
                units: units || lot.units,
            }));
            return submission;
        }
        submission[lotComponent.id][lotIdx] = [{
            lot: "",
            historial: [],
            minDate: "",
            production_date: "",
            totalAmount: 0,
            editedAmount: formatLotEditedAmount(quantity),
            isNew: true,
            units,
        }];
        return submission;
    }

    if (isReceivingLog && Array.isArray(currentLots) && currentLots.length > 0 && typeof currentLots[0] === "object") {
        let quantityOnLots = 0;
        currentLots.forEach((lot) => {
            quantityOnLots += parseFloat(lot.editedAmount || 0);
        });
        if (quantityOnLots < quantity || quantityOnLots > quantity) {
            const dividedQuantity = (quantity / currentLots.length).toFixed(3);
            submission[lotComponent.id][lotIdx] = currentLots.map((lot) => ({
                ...lot,
                editedAmount: dividedQuantity,
            }));
        }
    }

    return submission;
}

/** Lot submission has real rows/amounts (not empty `[]`). Used to avoid refocus reopening when data exists. */
export function lotFieldHasMeaningfulLots(value) {
    if (value == null || value === "") return false;
    if (typeof value === "string") return value.trim().length > 0;
    if (!Array.isArray(value) || value.length === 0) return false;
    return value.some((lot) => {
        if (!lot || lot === "default_lot") return false;
        if (typeof lot === "string") return lot.trim().length > 0;
        if (lot.isNew === true) {
            const code = lot.lot != null ? String(lot.lot).trim() : "";
            const amt = parseFloat(lot.editedAmount ?? lot.amount ?? NaN);
            return code.length > 0 || (!Number.isNaN(amt) && amt > 0);
        }
        if (lot.lot != null && String(lot.lot).trim().length > 0) return true;
        if (Array.isArray(lot.historial)) {
            return lot.historial.some((b) => {
                if (!b || b.hide) return false;
                const ed =
                    b.editedAmount != null && String(b.editedAmount).trim() !== ""
                        ? parseFloat(b.editedAmount)
                        : NaN;
                const am =
                    b.amount != null && String(b.amount).trim() !== ""
                        ? parseFloat(b.amount)
                        : NaN;
                return (!Number.isNaN(ed) && ed > 0) || (!Number.isNaN(am) && am > 0);
            });
        }
        const flat = parseFloat(lot.editedAmount ?? lot.amount ?? NaN);
        return !Number.isNaN(flat) && flat > 0;
    });
}

export function receivingRowHasProductForLotsPicker(ingredientName, amount) {
    const ing = ingredientName && String(ingredientName).trim();
    let amtOk = false;
    if (amount != null && String(amount).trim() !== "") {
        const n = parseFloat(String(amount).replace(/,/g, ""));
        amtOk = !Number.isNaN(n) && n > 0;
    }
    return !!(ing || amtOk);
}

/** Open lots UI on mobile when preset lot codes exist OR receiving row has product/qty (iqops2-style). */
export function shouldOpenLotsPickerMobile(
    isInventoryReceivingForm,
    options,
    ingredientOptions,
    ingredientName,
    amount
) {
    const o = options && typeof options === "object" ? options : [];
    const io = ingredientOptions && typeof ingredientOptions === "object" ? ingredientOptions : [];
    if (o.length > 0) return true;
    if (io.length > 0) return true;
    return !!(isInventoryReceivingForm && receivingRowHasProductForLotsPicker(ingredientName, amount));
}

export function getTotalSelected(lotsSelected) {
    if (!lotsSelected || typeof lotsSelected != "object") return 0;
    var total = 0;
    lotsSelected.map((lot) => {
        if (lot?.historial && !lot.isNew) {
            lot.historial.map((batch) => {
                if (!batch?.hide) {
                    total += batch?.editedAmount != undefined ? !batch.editedAmount ? 0 : parseFloat(formatStringNumber(batch.editedAmount)) : parseFloat(formatStringNumber(batch.amount));
                    //if(lotsSelected[0].historial[0].itemName == "Salt"){
                    //    console.log(batch?.editedAmount != undefined ? !batch.editedAmount ? 0 : parseFloat(batch.editedAmount) : parseFloat(batch.amount));
                    //    console.log(total)
                    //}
                }
            })
        } else {
            total += lot?.editedAmount != undefined ? !lot.editedAmount ? 0 : parseFloat(formatStringNumber(lot.editedAmount)) : parseFloat(formatStringNumber(lot.amount));
            //if(lotsSelected[0].historial[0].itemName == "Salt"){
            //    console.log(lot?.editedAmount != undefined ? !lot.editedAmount ? 0 : parseFloat(lot.editedAmount) : parseFloat(lot.amount));
            //    console.log(total)
            //}
        }
    })
    //
    if(total % 1 != 0 && !validateDecimals(total.toString()))total = parseFloat(total).toFixed(3);
    return total;
}

export function getPreselectedLotCodes(defaultLabel, id, components, submission, position, lotCodes) {
    var quantity = "";
    var units = "";
    var quantityComponent = null;
    var unitsComponent = null;
    unitsComponent = getComponentByanotherComponentId(id, "units", components);

    var preselectedLots = [];
    if (defaultLabel == "lotcode") {
        quantityComponent = getComponentByanotherComponentId(id, "quantity", components);
        if (!quantityComponent && this.props.isShipmentLog) quantityComponent = getComponentByanotherComponentId(id, "quantityIngredient", components);
    } else if (defaultLabel == "lotcode_finished") {
        quantityComponent = getComponentByanotherComponentId(id, "quantityFinishedGoods", components);
    } else if (defaultLabel == "lotcode_wip") {
        quantityComponent = getComponentByanotherComponentId(id, "quantityWIP", components);
    }
    if (quantityComponent) {
        quantity = getComponentSubmissionByDefaultLabel(quantityComponent.defaultLabel, components, submission, quantityComponent.section_id, position);
    }
    if (unitsComponent) {
        units = getComponentSubmissionByDefaultLabel(unitsComponent?.defaultLabel, components, submission, unitsComponent?.section_id, position);
    }
    if (quantity) quantity = parseFloat(quantity);
    if (quantity > 0) {
        lotCodes.map((lotCode, idx) => {
            if (quantity > 0) {
                if (lotCode?.historial) {
                    lotCode.historial.map((batch) => {
                        if (quantity > 0) {
                            var rest = batch?.amount - quantity;
                            if (rest >= 0) {
                                batch.editedAmount = (quantity % 1 != 0 && !validateDecimals(quantity.toString())) ? (quantity).toFixed(3) : quantity;
                                quantity = 0;
                            } else {
                                quantity = rest * -1;
                                batch.editedAmount = (parseFloat(quantity) % 1 != 0 && !validateDecimals(quantity.toString())) ? parseFloat(batch?.amount).toFixed(3) : parseFloat(quantity);
                            }
                        } else {
                            batch.hide = true;
                        }

                        return batch;
                    })
                }
                preselectedLots.push(lotCode);
            }
        })
        if (quantity > 0) {
            preselectedLots.push({
                lot: "",
                historial: [],
                minDate: "",
                production_date: "",
                totalAmount: 0,
                editedAmount: (quantity % 1 != 0 && !validateDecimals(quantity.toString())) ? quantity.toFixed(3) : quantity,
                isNew: true,
                units
            })
        }
    } else {
        preselectedLots = lotCodes?.length ? [lotCodes[0]] : [];
    }
    return preselectedLots;
}
export function validateDecimals(val) {
    var decimals = val.split('.');
    var valid = true;
    if (decimals[1]) {
        if (decimals[1]?.length > 3) {
            valid = false;
        }
    }
    if (decimals.length > 2) valid = false;
    return valid;
}
export function formatStringNumber(str) {
    if (!str || typeof str !== "string") return str;
    let s = str.replace(/[^0-9.\-]/g, "");
    const hasMinus = s.startsWith("-");
    s = s.replace(/-/g, "");
    if (hasMinus) s = "-" + s;
    const parts = s.split(".");
    if (parts.length > 2) s = parts[0] + "." + parts.slice(1).join("");
    return s;
}

/** Recipe batch size, yield, and lot amounts: digits and at most one decimal point (no letters/symbols). */
export function getRequiredAmount(components, id, position, isRecipe, submission, defaultLabel, defaultYield) {
  var amount = "";
  var component = components.find((comp) => comp.type != "section" && comp.id == id);
  var section = components.find((comp) => comp.type == "section" && comp.section_id == component?.section_id);

  if (section) {
    var quantityComponent = getComponentByanotherComponentId(id, "quantity", components);
    if (isRecipe) {
      if (submission) {
        if (quantityComponent) {
          amount = getComponentDefaultSubmit(components, submission, defaultLabel, quantityComponent?.id, position, defaultYield);
        }
      }
    } else {
      if (section?.defaultSubmission) {
        if (section?.defaultSubmission[quantityComponent?.id]) {
          if (section?.defaultSubmission[quantityComponent?.id][position]) {
            amount = section.defaultSubmission[quantityComponent.id][position];
          }
        }
      }
    }
  }
  return amount;
}

export function inputFocus(textInputRef) {
  if (textInputRef && textInputRef.current && textInputRef.current.focus) {
    textInputRef.current.focus();
  }
}

export function sanitizeRecipeNumericInput(str) {
    if (str == null || typeof str !== "string") return str;
    let out = "";
    let dotSeen = false;
    for (let i = 0; i < str.length; i++) {
        const c = str[i];
        if (c >= "0" && c <= "9") out += c;
        else if (c === "." && !dotSeen) {
            dotSeen = true;
            out += c;
        }
    }
    return out;
}

export function calculateRelevance(item, search) {
    let score = 0;
    const name = item?.item ? item?.item?.toLowerCase() : item?.itemName ? item?.itemName.toLowerCase() : item?.namePackaging ? item?.namePackaging.toLowerCase() : "";
    const term = search.toLowerCase();

    if (name === term) {
        score += 100;
    }
    else if (name.startsWith(term)) {
        score += 50;
    }
    else if (name.includes(term)) {
        score += 20;
    }
    return score;
}
export function sortSearch(a, b, search) {
    const itemA = calculateRelevance(a, search);
    const itemB = calculateRelevance(b, search);
    
    return itemB - itemA; 
}
const LOCATION_HIERARCHY = ["site", "zone", "aisle", "rackBay", "shelfLevel", "bin"];

function extractLocationPartId(part) {
  if (!part || typeof part !== "object") return "";
  if (part._id != null && part._id !== "") {
    if (typeof part._id === "object" && part._id.$oid) return String(part._id.$oid);
    return String(part._id);
  }
  if (part.id != null && part.id !== "") return String(part.id);
  return "";
}

/** _id of the deepest populated location level (site → bin), not a parent level. */
export const getLocationId = (location) => {
  if (!location || typeof location !== "object") return "";

  var deepestPart = null;
  for (var i = 0; i < LOCATION_HIERARCHY.length; i++) {
    var level = LOCATION_HIERARCHY[i];
    var part = location[level];
    if (part && part.locationName) deepestPart = part;
  }

  if (!deepestPart) {
    for (var j = 0; j < LOCATION_HIERARCHY.length; j++) {
      var fallbackPart = location[LOCATION_HIERARCHY[j]];
      if (extractLocationPartId(fallbackPart)) deepestPart = fallbackPart;
    }
  }

  return extractLocationPartId(deepestPart);
}
export const isDefaultLocation = (location) => {
  return location?.site?.defaultLocation;
}
